<template>
   <div class="home">
<div class="overlay">
    <div class="overlay__grid">
      <div class="overlay__close"></div>
      <div class="overlay__signup">
        <a href="https://lessonpro.co.uk/contact-us">
          Contact
        </a>
    </div>
    </div>
    <nav class="overlay__nav">
      <ul class="menu">
        <li><a href="https://lessonpro.co.uk/why-lesson-pro">Why Lesson Pro</a></li>
        <li><a href="https://lessonpro.co.uk/pricing/">Pricing</a></li>
        <li><a href="https://lessonpro.co.uk/support/">Support</a></li>
        <li><a href="https://lessonpro.co.uk/news/">News</a></li>
      </ul>
    </nav>
    <div class="overlay__info">
        <a class="email" href="mailto:info@lessonpro.co.uk">info@lessonpro.co.uk</a>
      <div class="overlay__info__socials">
        <ul>
          <li><a class="twitter" href="https://twitter.com/lessonprogolf" target="_blank"></a></li>
          <li><a class="facebook" href="https://www.facebook.com/lessonprogolf" target="_blank"></a></li>
          <li><a class="instagram" href="https://www.instagram.com/lessonprogolf/" target="_blank"></a></li>
          <li><a class="youtube" href="https://www.youtube.com/channel/UCgDQjjmj75tKg2N2qKpbNUQ" target="_blank"></a></li>
        </ul>
      </div>
    </div>
  </div>

  <navigation />
  <div class="prop"></div>

  <main class="content white">
    <div class="container">
      <div class="content__grid">

        <div class="content__grid__col1">

           <div class="content__title">
            &nbsp;
          </div>
         
        </div>
        <div class="content__grid__col2">

          <div class="content__form">

            <div class="content__title">
            Page not found
          </div>

          <label for="">You've landed on a page that doesn't exist &ndash; click the button below to go to sign up and create your Lesson Pro account.</label>
          <br>
          <router-link to="/" class="button btn--arrow-right btn--secondary">Go to sign up</router-link>

          </div>

        </div>
      </div>
    </div>
  </main>

  <footer-nav />
  </div>
</template>

<script>
import Navigation from '@/components/navigation'
import FooterNav from '@/components/footer-nav'
export default {
  components: {Navigation, FooterNav}
}
</script>
